import { INDEX_MINT, INDEX_NAME, STONKFUN_TOKEN } from "../lib/data";
import { Link } from "wouter";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <p style={{ margin: 0, maxWidth: "36rem", lineHeight: 1.5 }}>
          Informational only — not financial advice. Basket tokens are on-chain
          StonkFun assets. Liquidity and payouts can vary by cycle.
        </p>
        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "center" }}>
          <a href={STONKFUN_TOKEN} target="_blank" rel="noreferrer">
            StonkFun
          </a>
          <a href="https://x.com/STONKS_INDEX" target="_blank" rel="noreferrer">
            X
          </a>
          {INDEX_MINT ? (
            <a href={`https://solscan.io/token/${INDEX_MINT}`} target="_blank" rel="noreferrer">
              Solscan
            </a>
          ) : null}
          <Link href="/docs">Docs</Link>
          <Link href="/faq">FAQ</Link>
          <Link href="/terms">Terms</Link>
          <Link href="/privacy">Privacy</Link>
          <span>© {new Date().getFullYear()} {INDEX_NAME}</span>
        </div>
      </div>
    </footer>
  );
}
